import {ParamListType} from "common";

export function ActionDescription(description: string)
{
	return (target: any) =>
	{
		target.prototype.description = description;
	};
}

export function ActionParameters(params: ParamListType)
{
	return (target: any) =>
	{
		target.prototype.paramTypes = params;
	};
}
